import React, { useEffect, useState, useRef } from "react";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { selectFormattedDemoCountries, selectFormattedLogisticCountries, fetchHomePageLogisticCountries } from "@/store/modern/slices/countrySlice";
import { supplierAndLogPartnterSuggetion, fetchsupplierAndPartnter } from "@/store/modern/slices/memberSlice";
import { map, isArray, isEmpty, split, trim } from 'lodash';
import ScreenLoaderHome from "@/components/common/ScreenLoaderHome";
import searchIcon from "@/assets/images/png/search-icon.png";
import defaultValues from "@/constant/defaultValues";
import companylogo from "@/images/Company-logo.svg";

import no_data_found from "@/assets/images/svg/no_data_found.svg";

import RegistrationPopup from "@/components/RegistrationPopup";
import { publicRoutePaths } from "@/routes/public.routes.config";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import { useAuth } from "@/AuthProvider";
import { privateRoutePaths } from "@/routes/private.route.config";
import { buildPath } from "@/utils/common";
import roles from "@/constant/roles.config";
import RadioButtonField from "@/components/RadioButtonField";
import { motion } from "framer-motion";

const Index = () => {
 const dispatch = useDispatch();
  const { user, isPreKYCUser, isDemoUser, isEndUser, isViewer } = useAuth();
  const searchRef = useRef(null);
  const countries = useSelector(selectFormattedDemoCountries);
  const logisticsCountries = useSelector(selectFormattedLogisticCountries);


  const [queryParam, setQueryParams] = useState({});
  const [data, setData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [industryData, setIndustryData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const { SHIPMENT_OPTION, SEARCH_BY_OPTION } = defaultValues;
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [query, setQuery] = useState(null);
  const [results, setResults] = useState({ companies: [], industries: [], hsCode: [] });
  const [loading, setLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [searchTxt, setSearchText] = useState(null);
  const [selectedShipment, setSelectedShipment] = useState(SHIPMENT_OPTION[1]);
  const [selectedSearchOption, setSelectedSearchOption] = useState(SEARCH_BY_OPTION[0]);
  const [supplierFlag, setSupplierFlag] = useState(false);
  const [logisticFlag, setLogisticFlag] = useState(false);
  const [shouldSubmit, setShouldSubmit] = useState(false);


  const navigate = useNavigate(null);


  const [smallmodalShow, setSmallModalShow] = useState(false);

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

 

  const handleClick = () => {
    setSmallModalShow(true);
  };

  const handleRegistrationPopup = () => {
    navigate(publicRoutePaths.REGISTRATION.path);
  }

  useEffect(() => {
    const search = window.location.search;

    if (search) {
      try {
        const params = new URLSearchParams(search.substring(1));
        const result = {};
        for (const [key, value] of params.entries()) {
          result[key] = value;
        }
        setQueryParams(result);
      } catch (err) {
        console.error("Failed to decode query:", err);
      }
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (Object.keys(queryParam).length > 0) {
        try {
          if (!isEmpty(queryParam)) {
            fetchDataFromParams({
              type: queryParam?.type ?? null,
              country: queryParam?.country ?? null,
              company: queryParam?.company ?? null,
              industry: queryParam?.industry ?? null,
              product: queryParam?.product ?? null,
              search: queryParam?.search ?? null,
              searchBy: queryParam?.searchBy ?? null,
              query: queryParam?.query ?? null,
            });
          }
        } catch (err) {
          console.error("Fetch Error:", err);
        }
      }
    };
    fetchData();
  }, [queryParam, dispatch]);

  const handleCountryChange = (cval) => {
    setSelectedCountry(cval);
    setSearchText(null);
    if (selectedShipment?.value == 'logistic' && cval != null) {
      setShouldSubmit(true);
    }
  };

  useEffect(() => {
    if (!isEmpty(queryParam?.type)) {
      if (queryParam.type === "logistic") {
        setSelectedShipment(SHIPMENT_OPTION[1]);

      } else {
        setSelectedShipment(SHIPMENT_OPTION[0]);

      }
    }
  }, [queryParam?.type]);

  useEffect(() => {
    if (!isEmpty(queryParam.query) && queryParam.type === "supplier") {
      setQuery(queryParam.query);
    }
    if (!isEmpty(queryParam.query) && !isEmpty(queryParam.company)) {
      setSelectedCompany(queryParam.company);
      setSelectedIndustry(null);
      setSelectedProduct(null);
    }
    if (!isEmpty(queryParam.query) && !isEmpty(queryParam.industry)) {
      setSelectedIndustry(queryParam.industry);
      setSelectedCompany(null);
      setSelectedProduct(null);
    }
    if (!isEmpty(queryParam.query) && !isEmpty(queryParam.product)) {
      const fullText = queryParam.query;
      const parts = split(fullText, ' - ');
      const code = trim(parts[0]);
      const description = trim(parts[1]);
      setSelectedProduct({
        code: code,
        description: description,
        codeAndDesc: fullText,
      });

      setSelectedIndustry(null);
      setSelectedCompany(null);
    }
    setSearchText(null);
  }, [queryParam?.type, queryParam?.query, queryParam?.company, queryParam?.industry, queryParam?.product]);

  useEffect(() => {
    // if (!isEmpty(queryParam) && queryParam.country && countries.length > 0) {
    //   const selected = countries.find((c) => c.countryCode === queryParam.country);
    //   if (selected) {
    //     setSelectedCountry(selected);
    //     setSearchText(null);
    //   }
    // }

    if (!isEmpty(queryParam) && queryParam.country && queryParam.type === "supplier" && countries.length > 0) {
      const selected = countries.find((c) => c.countryCode === queryParam.country);
      if (selected) {
        setSelectedCountry(selected);
        setSearchText(null);
      }
    } else if (!isEmpty(queryParam) && queryParam.country && queryParam.type === "logistic" && logisticsCountries.length > 0) {
      const selected = logisticsCountries.find((c) => c.countryCode === queryParam.country);
      if (selected) {
        setSelectedCountry(selected);
        setSearchText(null);
      }
    }

  }, [countries, logisticsCountries, queryParam.country]);


  useEffect(() => {
    if (!isEmpty(queryParam) && queryParam.searchBy) {
      if (queryParam.searchBy === "location") {
        setSelectedSearchOption(SEARCH_BY_OPTION[0]);
        setSearchText(null);
      } else {
        setSelectedSearchOption(SEARCH_BY_OPTION[1]);
        setSelectedCountry(null);
        if (!isEmpty(queryParam) && !isEmpty(queryParam.search)) {
          setSearchText(queryParam.search);
        }
      }

    }
  }, [queryParam.searchBy, queryParam.search]);



  const handleSearchChange = (val) => {
    if (!val) {
      return;
    }
    setSelectedSearchOption(val);
    setSelectedCountry(null);
    setSearchText(null);
  }

  const handleInputSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

  };
  const handleInputChange = (e) => {

    const value = e.target.value;
    setQuery(value);
    setSelectedProduct(null);
    setSelectedCompany(null);
    setSelectedIndustry(null);

    if (value.length >= 2) {
      fetchSuggestions(value);
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
      setResults({ companies: [], industries: [], hsCode: [] });
    }

  };

  const handleInputFocus = () => {
    if (typeof query === 'string' && query.length > 1) {
      setShowSuggestions(true);
      fetchSuggestions(query);
    }
  };

  const fetchSuggestions = async (text) => {
    setLoading(true);

    let searchTerm = text;
    if (selectedProduct && selectedProduct.description) {
      searchTerm = selectedProduct.description;
    }
    try {
      const response = await dispatch(supplierAndLogPartnterSuggetion(searchTerm));
      if (response && response.meta?.requestStatus === "fulfilled") {
        if (response.payload?.status === "success") {
          setResults(response.payload);
          return;
        }
      }

    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setResults({ companies: [], industries: [], hsCode: [] });
    } finally {
      setLoading(false);
    }
  };

  const handleSelectSuggestion = (value, type) => {
    setShowSuggestions(false);

    if (type === "hsCodeDescription") {
      if (!value || !value.code || !value.description) return;

      const fullText = `${value.code} - ${value.description}`;
      setQuery(fullText);
      setSelectedProduct({
        code: value.code,
        description: value.description,
        codeAndDesc: fullText,
      });

      setSelectedCompany(null);
      setSelectedIndustry(null);
    } else if (type === "company") {
      const cleanValue = value.trim();
      setQuery(cleanValue);
      setSelectedCompany(cleanValue);
      setSelectedIndustry(null);
      setSelectedProduct(null);
    } else if (type === "industry") {
      const cleanValue = value.trim();
      setQuery(cleanValue);
      setSelectedIndustry(cleanValue);
      setSelectedCompany(null);
      setSelectedProduct(null);
    }
    setSearchText(null);
    setResults({ companies: [], industries: [], hsCode: [] });

    setShouldSubmit(true);
  };

  const fetchDataFromParams = async (params) => {
    setShowLoader(true);
    try {
      const response = await dispatch(fetchsupplierAndPartnter(params));
      if (response?.meta?.requestStatus === "fulfilled") {
        if (response.payload?.status === "success") {

          const data0 = response.payload?.data;
          const data = Array.isArray(data0) ? data0 : (data0?.data || []);
          if (isArray(data)) {
            if (params.type === 'logistic') {
              setLogisticFlag(data.length === 0);
            } else if (params.type === 'supplier') {
              setSupplierFlag(data.length === 0);
            }
            setData(data);
            setCompanyData([]);
            setIndustryData([]);

          } else if (data && typeof data === 'object') {
            const companiesData = data.companies || [];
            const industriesData = data.industries || [];

            const isEmpty = companiesData.length === 0 && industriesData.length === 0;

            if (params.type === 'logistic') {
              setLogisticFlag(isEmpty);
            } else if (params.type === 'supplier') {
              setSupplierFlag(isEmpty);
            }

            setData(data);
            setCompanyData(companiesData);
            setIndustryData(industriesData);
          }
        }
      }
    } catch (err) {
      console.error("Error fetching data:", err);

    } finally {
      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    }
  };


  const handleTypeChange = () => {
    setSelectedShipment((prev) => {
      const newValue =
        prev.value === "supplier" ? SHIPMENT_OPTION[1] : SHIPMENT_OPTION[0];
      return newValue;
    });

    setQuery(null);
    setSelectedIndustry(null);
    setSelectedCompany(null);
    setSelectedProduct(null);
    setSelectedCountry(null);
    setSelectedSearchOption(SEARCH_BY_OPTION[0]);
    setSearchText(null);
    setData([]);
    setCompanyData([]);
    setIndustryData([]);
    setSupplierFlag(false);
    setLogisticFlag(false);
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        type: selectedShipment?.value ?? null,
        country: selectedCountry?.countryCode ?? null,
        company: selectedCompany ?? null,
        industry: selectedIndustry ?? null,
        product: selectedProduct?.code ?? null,
        search: searchTxt ?? null,
        searchBy: selectedSearchOption?.value ?? null,
        query: query ?? null,
      };

      fetchDataFromParams(payload);
    } catch (err) {
      console.log("Error ==== ", err);
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClearClick = () => {
    setSearchText("");
  }

  const handleSupplierClearClick = () => {
    setQuery("");
    setSelectedCompany("");
    setSelectedIndustry("");
    setSelectedProduct("");
  }

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  useEffect(() => {
    if (user) {
      if (user?.role_slug?.slug === "SUP_ADM") {
        navigate(`/${getPrefix()}${privateRoutePaths.MANAGE_LEADS.path}`);
      } else if (user?.role_slug?.slug === "END_USER") {
        if (user?.company_status === 1) {
          navigate(`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`);
        }
      } else if (user?.role_slug?.slug === "DEMO") {
        navigate(`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`);
      } else if (user?.role_slug?.slug === "VIEWER") {
        navigate(`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`);
      } else if (user?.role_slug?.slug === "PRE_KYC") {
        navigate(`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`)
      } else {
        navigate(publicRoutePaths.SEARCH_DETAIL.path);
      }
    }
  }, [user]);

  useEffect(() => {
    if (shouldSubmit) {
      handleSubmit();
      setShouldSubmit(false);
    }
  }, [shouldSubmit, query, selectedProduct, selectedCompany, selectedIndustry]);

   useEffect(() => {
        dispatch(fetchHomePageLogisticCountries());
    }, [dispatch]);


  return (
    <>
      <section className="search-detail-wrape">
        <SeoHelmet
          title={seoConfig.searchDetail.title}
          description={seoConfig.searchDetail.description}
          keywords={seoConfig.searchDetail.keywords}
          author={seoConfig.searchDetail.author}
        />
        {showLoader && <ScreenLoaderHome />}
        {/* inner banner wrape START  */}
        <div className="inner-banner">
          <div className="container">
            <div className="content-wrape desk-hide">
              <h2>
                <motion.span className="light animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >Find</motion.span>
                <motion.span className="blue-text animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > Global</motion.span><br />
                <motion.span className="black animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > Partners</motion.span>
              </h2>
              <motion.p className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.1 }}
                custom={0.1}
                variants={fadeUpVariant}
              >Search and connect with global suppliers and logistics experts.</motion.p>
            </div>
          </div>
        </div>
        {/* inner banner wrape END  */}

        <div className="find-partner-stats-wrape">
          <motion.div className="find-parter-wrape animate-child"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            <div className="inner">
              <div className="head">
                <h3>FIND <span>{selectedShipment?.value === 'supplier' ? 'SUPPLIERS' : 'LOGISTICS PARTNER'}</span></h3>
                <div className="right-section">
                  <div className="trigger-wrapes">
                    {/* <span className="text">Suppliers</span> */}
                    {/* <span className="switch-wrapes">
                      <label className="switch">

                        <input
                          type="checkbox"
                          checked={selectedShipment.value === "logistic"}
                          onChange={typeChange}
                        />

                        <span className="slider-switch round"></span>
                      </label>
                    </span> */}
                    {/* <span className="text dull">
                      Logistics
                    </span> */}
                    <span>
                      <div className="d-flex">
                        <div className="r-buttn">
                          <label className="">
                            <RadioButtonField
                              onChange={(e) =>
                                handleTypeChange(e)
                              }
                              checked={selectedShipment.value === "logistic"}
                            />
                            Logistics
                          </label>
                        </div>
                        <div className="r-buttn">
                          <label className="">
                            <RadioButtonField
                              onChange={(e) =>
                                handleTypeChange(e)
                              }
                              checked={selectedShipment.value === "supplier"}
                            />
                            Suppliers
                          </label>
                        </div>
                      </div>
                    </span>
                  </div>


                </div>
              </div>
              <div className="body">
                <div className="form-section">
                  <div className="container">
                    <div className="row">
                      {selectedShipment?.label === "Suppliers" ? (
                        <>
                          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
                            <div className="input-wrape">
                              <div className="input-pad select-wrape">
                                <Select
                                  name="country_id"
                                  options={countries}
                                  value={selectedCountry}
                                  onChange={handleCountryChange}
                                  placeholder="Select country"
                                  classNamePrefix={"Drop-down-menu"}
                                  noOptionsMessage={() => "No Country Found"}
                                  isClearable={true}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12" ref={searchRef}>
                            <div className="input-wrape">
                              <div className="input-pad">
                                <input
                                  type="text"
                                  placeholder="By product, industry or company"
                                  value={query}
                                  onChange={handleInputChange}
                                  onFocus={handleInputFocus}
                                  autoComplete="off"
                                  className="input"
                                />
                                <span
                                  onClick={handleSupplierClearClick}
                                  style={{
                                    position: 'absolute',
                                    top: '50%',
                                    right: '10px',
                                    transform: 'translateY(-50%)',
                                    display: query ? 'flex' : 'none',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
                                </span>
                              </div>

                              {loading && (
                                <div className="load-dotes">...</div>
                                // suggession buffering
                              )}

                              {showSuggestions && (results.companies.length > 0 || results.industries.length > 0 || results.hsCode.length > 0) && (
                                // dd show suggestion
                                <div className="dd-wrape">
                                  {results.hsCode.length > 0 && (
                                    <>
                                      {selectedProduct?.code ? (
                                        <ul >
                                          {results.hsCode
                                            .filter((hsCode) => hsCode.code === selectedProduct.code)
                                            .map((hsCode, idx) => (
                                              <li
                                                key={idx}
                                                onClick={() => handleSelectSuggestion(hsCode, "hsCodeDescription")}
                                              >
                                                <span style={{ fontWeight: "bold" }}>{hsCode.code}</span> - {hsCode.description}
                                              </li>
                                            ))}
                                        </ul>
                                      ) : (
                                        <>
                                          <h5 className="sub-head">Product</h5>
                                          <ul >
                                            {results.hsCode.map((hsCode, idx) => (
                                              <li
                                                key={idx}
                                                onClick={() => handleSelectSuggestion(hsCode, "hsCodeDescription")}
                                              >
                                                <span >{hsCode.code}</span> - {hsCode.description}
                                              </li>
                                            ))}
                                          </ul>
                                        </>
                                      )}
                                    </>
                                  )}

                                  {results.industries.length > 0 && (
                                    <>
                                      <h5 className="sub-head">Industries</h5>
                                      <ul>
                                        {map(results?.industries, (industry, idx) => (
                                          <li
                                            key={idx}
                                            onClick={() => handleSelectSuggestion(industry, "industry")}
                                          >
                                            {industry}
                                          </li>
                                        ))}
                                      </ul>
                                    </>
                                  )}

                                  {results.companies.length > 0 && (
                                    <>
                                      <h5 className="sub-head">Companies</h5>
                                      <ul >
                                        {map(results?.companies, (company, idx) => (
                                          <li
                                            key={idx}
                                            onClick={() => handleSelectSuggestion(company, "company")}
                                          >
                                            {company}
                                          </li>
                                        ))}
                                      </ul>
                                    </>
                                  )}


                                </div>
                              )}

                              {/* No data found message */}
                              {showSuggestions &&
                                !loading &&
                                results.companies.length === 0 &&
                                results.industries.length === 0 &&
                                results.hsCode.length === 0 &&
                                query.length > 1 && (
                                  <div className="no-result">
                                    No Results
                                  </div>
                                )}
                            </div>
                          </div>

                        </>
                      ) : (
                        <>
                          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
                            <div className="input-wrape">
                              <div className="input-pad select-wrape">
                                <Select
                                  name="search"
                                  options={SEARCH_BY_OPTION}
                                  value={selectedSearchOption}
                                  onChange={handleSearchChange}
                                  placeholder="Search by"
                                  classNamePrefix={"Drop-down-menu"}
                                  noOptionsMessage={() => "No Search Found"}
                                // menuPlacement="top"
                                />
                              </div>
                            </div>
                          </div>

                          {selectedSearchOption?.value === 'location' && (
                            <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12">
                              <div className="input-wrape">
                                <div className="input-pad select-wrape">

                                  <Select
                                    name="country_id"
                                    options={logisticsCountries}
                                    value={selectedCountry}
                                    onChange={handleCountryChange}
                                    placeholder="Select country"
                                    classNamePrefix={"Drop-down-menu"}
                                    noOptionsMessage={() => "No Country Found"}
                                    isClearable={true}
                                  />
                                </div>
                              </div>
                            </div>
                          )}


                          {selectedSearchOption?.value === 'company_name' && (
                            <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12">
                              <div className="input-wrape">
                                <div className="input-pad">
                                  <input type="text"
                                    placeholder={`Enter company name`}
                                    value={searchTxt}
                                    onChange={handleInputSearchChange}
                                    autoComplete="off"
                                    className="input" />
                                  <span
                                    onClick={handleClearClick}
                                    style={{
                                      position: 'absolute',
                                      top: '50%',
                                      right: '10px',
                                      transform: 'translateY(-50%)',
                                      display: searchTxt ? 'flex' : 'none',
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}

                    </div>


                  </div>
                  <button type="submit" className="btn icon-btn-primary" onClick={handleSubmit}>
                    <img src={searchIcon} alt="" className="" /> Search
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* suggetion searcks */}
        <div className="container list-wrape">
          <div className="row">
            {isArray(data) && map(data, (item, key) => (
              <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6">
                <div className="card">
                  <div key={key} className="logistic-pad inner-pad">
                    <div className="head-section">
                      <div className="thumb-img">
                        <img
                          src={
                            !isEmpty(item.company_logo)
                              ? item.company_logo
                              : companylogo
                          }
                          alt="Logo"
                          className=""
                          key={`log_5.${key}`}
                        />
                      </div>
                      <div className="head-text">
                        <div className="left-text">
                          <h6>{!isEmpty(item.company_name) ? item.company_name : " - "}</h6>
                          <span>
                            <svg version="1.1" id="fi_747340" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" width="16" class="me-1"><g><g><path d="M256,110.062c-52.412,0-95.053,42.641-95.053,95.053s42.641,95.053,95.053,95.053s95.053-42.641,95.053-95.053 S308.413,110.062,256,110.062z M256,260.146c-30.344,0-55.031-24.687-55.031-55.031s24.687-55.031,55.031-55.031 s55.031,24.687,55.031,55.031S286.344,260.146,256,260.146z"></path></g></g><g><g><path d="M256,0C142.899,0,50.885,92.015,50.885,205.115v5.67c0,57.2,32.794,123.856,97.474,198.113 c46.888,53.832,93.121,91.368,95.065,92.94L256,512l12.576-10.161c1.945-1.572,48.178-39.108,95.065-92.94 c64.679-74.258,97.474-140.913,97.474-198.113v-5.67C461.115,92.015,369.101,0,256,0z M421.093,210.786 c0,96.665-124.551,213.68-165.093,249.202C215.447,424.455,90.907,307.444,90.907,210.786v-5.67 c0-91.032,74.061-165.093,165.093-165.093s165.093,74.061,165.093,165.093V210.786z"></path></g></g>
                            </svg>
                            {/* {!isEmpty(item.member_city) ? item.member_city.name + " - " : ""} {" "} {!isEmpty(item.country) ? item.country.name : " - "} {!isEmpty(item.city) ? item.city + " - " : ""} {" "} {!isEmpty(item.country_name) ? item.country_name : " - "} */}
                            {(() => {
                              const city = !isEmpty(item.member_city)
                                ? item.member_city.name
                                : (!isEmpty(item.city) ? item.city : null);

                              const country = !isEmpty(item.country)
                                ? item.country.name
                                : (!isEmpty(item.country_name) ? item.country_name : null);

                              const parts = [city, country].filter(Boolean);
                              return parts.length > 0 ? parts.join(" - ") : "-";
                            })()}
                          </span>
                          <span className="industry">
                            {!isEmpty(item.industy_name) ? item.industy_name : " - "}
                          </span>
                          <span><svg xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="me-1">
                            <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-8a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 10c-4.42 0-8 2.24-8 5v3h16v-3c0-2.76-3.58-5-8-5Zm-6 6v-1c0-1.42 2.69-3 6-3s6 1.58 6 3v1H6Z" />
                          </svg>
                            {item.first_name}{' '}{item.last_name}</span>
                          <span><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="me-1"
                          >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
                          </svg>**************</span>
                          <span>  <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="me-1"
                          >
                            <path
                              d="M14.05 6C15.0268 6.19057 15.9244 6.66826 16.6281 7.37194C17.3318 8.07561 17.8095 8.97326 18 9.95M14.05 2C16.0793 2.22544 17.9716 3.13417 19.4163 4.57701C20.8609 6.01984 21.7721 7.91101 22 9.94M18.5 21C9.93959 21 3 14.0604 3 5.5C3 5.11378 3.01413 4.73086 3.04189 4.35173C3.07375 3.91662 3.08968 3.69907 3.2037 3.50103C3.29814 3.33701 3.4655 3.18146 3.63598 3.09925C3.84181 3 4.08188 3 4.56201 3H7.37932C7.78308 3 7.98496 3 8.15802 3.06645C8.31089 3.12515 8.44701 3.22049 8.55442 3.3441C8.67601 3.48403 8.745 3.67376 8.88299 4.05321L10.0491 7.26005C10.2096 7.70153 10.2899 7.92227 10.2763 8.1317C10.2643 8.31637 10.2012 8.49408 10.0942 8.64506C9.97286 8.81628 9.77145 8.93713 9.36863 9.17882L8 10C9.2019 12.6489 11.3501 14.7999 14 16L14.8212 14.6314C15.0629 14.2285 15.1837 14.0271 15.3549 13.9058C15.5059 13.7988 15.6836 13.7357 15.8683 13.7237C16.0777 13.7101 16.2985 13.7904 16.74 13.9509L19.9468 15.117C20.3262 15.255 20.516 15.324 20.6559 15.4456C20.7795 15.553 20.8749 15.6891 20.9335 15.842C21 16.015 21 16.2169 21 16.6207V19.438C21 19.9181 21 20.1582 20.9007 20.364C20.8185 20.5345 20.663 20.7019 20.499 20.7963C20.3009 20.9103 20.0834 20.9262 19.6483 20.9581C19.2691 20.9859 18.8862 21 18.5 21Z"
                              stroke="#df0024"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </svg>**********</span>
                        </div>
                        <button
                          id={item.id ? `registration_${item.id}` : "registration"}
                          className="btn secondry-btn small mt-2"
                          onClick={handleClick}>
                          View Details
                        </button>
                      </div>
                    </div>
                    {/* <div className="right-wrape">
                      <div className="detail-wrape">
                        <p><span>Name</span> {item.first_name}{' '}{item.last_name}</p>
                        <p><span>Email</span> **************</p>
                        <p><span>Mobile</span> **********</p>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            ))}


            {isArray(companyData) && map(companyData, (item, key) => (
              <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6">
                <div className="card">
                  <div key={key} className="logistic-pad inner-pad">
                    <div className="thumb-img">
                      <img
                        src={
                          !isEmpty(item.company_logo)
                            ? item.company_logo
                            : companylogo
                        }
                        alt="Logo"
                        className=""
                        key={`log_5.${key}`}
                      />
                    </div>
                    <div className="right-wrape">
                      <div className="head-text">
                        <div className="left-text">
                          <h6>{!isEmpty(item.company_name) ? item.company_name : " - "}</h6>
                          <span>
                            <svg version="1.1" id="fi_747340" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" width="16" class="me-1"><g><g><path d="M256,110.062c-52.412,0-95.053,42.641-95.053,95.053s42.641,95.053,95.053,95.053s95.053-42.641,95.053-95.053 S308.413,110.062,256,110.062z M256,260.146c-30.344,0-55.031-24.687-55.031-55.031s24.687-55.031,55.031-55.031 s55.031,24.687,55.031,55.031S286.344,260.146,256,260.146z"></path></g></g><g><g><path d="M256,0C142.899,0,50.885,92.015,50.885,205.115v5.67c0,57.2,32.794,123.856,97.474,198.113 c46.888,53.832,93.121,91.368,95.065,92.94L256,512l12.576-10.161c1.945-1.572,48.178-39.108,95.065-92.94 c64.679-74.258,97.474-140.913,97.474-198.113v-5.67C461.115,92.015,369.101,0,256,0z M421.093,210.786 c0,96.665-124.551,213.68-165.093,249.202C215.447,424.455,90.907,307.444,90.907,210.786v-5.67 c0-91.032,74.061-165.093,165.093-165.093s165.093,74.061,165.093,165.093V210.786z"></path></g></g>
                            </svg>
                            {!isEmpty(item.member_city) ? item.member_city.name + " - " : ""} {" "} {!isEmpty(item.country) ? item.country.name : " - "}
                          </span>
                        </div>
                        <button
                          id={item.id ? `registration_${item.id}` : "registration"}
                          className="btn outline small"
                          onClick={handleClick}>
                          View Details
                        </button>
                      </div>
                      <div className="detail-wrape">
                        <p>
                          <span>Name</span> {item.first_name}{' '}{item.last_name}</p>
                        <p>
                          <span>Email</span> **************</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}


            {isArray(industryData) && map(industryData, (item, key) => (
              <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6">
                <div className="card">
                  <div key={key} className="logistic-pad inner-pad">
                    <div className="thumb-img">
                      <img
                        src={
                          !isEmpty(item.company_logo)
                            ? item.company_logo
                            : companylogo
                        }
                        alt="Logo"
                        className=""
                        key={`log_5.${key}`}
                      />
                    </div>
                    <div className="right-wrape">
                      <div className="head-text">
                        <div className="left-text">
                          <h6>{!isEmpty(item.company_name) ? item.company_name : " - "}</h6>
                          <span>
                            <svg version="1.1" id="fi_747340" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" width="16" class="me-1"><g><g><path d="M256,110.062c-52.412,0-95.053,42.641-95.053,95.053s42.641,95.053,95.053,95.053s95.053-42.641,95.053-95.053 S308.413,110.062,256,110.062z M256,260.146c-30.344,0-55.031-24.687-55.031-55.031s24.687-55.031,55.031-55.031 s55.031,24.687,55.031,55.031S286.344,260.146,256,260.146z"></path></g></g><g><g><path d="M256,0C142.899,0,50.885,92.015,50.885,205.115v5.67c0,57.2,32.794,123.856,97.474,198.113 c46.888,53.832,93.121,91.368,95.065,92.94L256,512l12.576-10.161c1.945-1.572,48.178-39.108,95.065-92.94 c64.679-74.258,97.474-140.913,97.474-198.113v-5.67C461.115,92.015,369.101,0,256,0z M421.093,210.786 c0,96.665-124.551,213.68-165.093,249.202C215.447,424.455,90.907,307.444,90.907,210.786v-5.67 c0-91.032,74.061-165.093,165.093-165.093s165.093,74.061,165.093,165.093V210.786z"></path></g></g>
                            </svg>
                            {!isEmpty(item.member_city) ? item.member_city.name + " - " : ""} {" "} {!isEmpty(item.country) ? item.country.name : " - "}
                          </span>
                        </div>
                        <button
                          id={item.id ? `registration_${item.id}` : "registration"}
                          className="btn outline small"
                          onClick={handleClick}>
                          View Details
                        </button>
                      </div>
                      <div className="detail-wrape">
                        <p>
                          <span>Name</span> {item.first_name}{' '}{item.last_name}</p>
                        <p>
                          <span>Email</span> **************</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>



        <div className="no-data-img">
          {selectedShipment.value === 'supplier' && supplierFlag && (
            <div className="no-dataImg">
              <div className="container">
                <div className="text-center p-3">
                  <img src={no_data_found} alt="" />
                </div>
              </div>
            </div>
          )}

          {selectedShipment.value === 'logistic' && logisticFlag && (
            <div className="no-dataImg">
              <div className="container">
                <div className="text-center p-3">
                  <img src={no_data_found} alt="" />
                </div>
              </div>
            </div>
          )}

          {
            isArray(data) && isArray(companyData) && isArray(industryData) && isEmpty(data) && isEmpty(companyData) && isEmpty(industryData) && !supplierFlag && !logisticFlag && (
              <div className="no-dataImg">
                <div className="container">
                  <div className="text-center p-3">
                    <img src={no_data_found} alt="" />
                  </div>
                </div>
              </div>
            )
          }


        </div>

        <div className="container">
          <div className="row justify-content-md-center justify-content-sm-center justify-content-center">
            {(isArray(data)
              ? data.length >= 6
              : (companyData.length + industryData.length >= 6)
            ) && (
                <Link
                  className="btn secondry-btn auto-width"
                  title="Load More"
                  onClick={handleClick}
                >
                  Load More
                </Link>
              )}
          </div>
        </div>



        {smallmodalShow && (
          <RegistrationPopup
            title=""
            smallmodalShow={smallmodalShow}
            setSmallModalShow={setSmallModalShow}
            onSubmit={handleRegistrationPopup}
            okButtonLabel="REGISTER NOW"
          >
            <div className="new-pop">
              <div className="img-wrape"></div>
              <div className="detail-wrape">
                <div className="inner">
                  <h5 className="registor-now">Grow With Us!</h5>
                  <h6>Register now to get more benefits!</h6>
                  <p className="registor-now-text">
                    Access special features, get personalized recommendations and connect with a growing community.
                  </p>
                  <Link to={publicRoutePaths.REGISTRATION.path} className="btn secondry-btn" target="_blank"
                    href={publicRoutePaths.REGISTRATION.path}
                  >Register Now</Link>
                </div>
              </div>
            </div>
          </RegistrationPopup>
        )}
      </section>
      <ConsentManager data={""} />
    </>
  );
}

export default Index;
